<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Configurações — Grupos de usuários
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        |  e
        strong  cadastrar
        |  grupos de usuários em
        strong  Configurações → Usuários → Grupos de usuários
        | .

      .toast.toast-primary
        | Exige
        strong  Grupos de usuários → Listar
        | . Para incluir ou editar, use
        strong  Grupos de usuários → Criar
        |  e
        strong  Grupos de usuários → Alterar
        | . O botão
        strong  Logs
        |  (na edição) exige
        strong  Logs → Listar
        | .

      h5.h5 1. Abrir Grupos de usuários
      ol
        li No menu lateral, clique em
          strong  Configurações
          | .
        li Expanda
          strong  Usuários
          |  e clique em
          strong  Grupos de usuários
          | .

      h5.h5 2. Listagem
      p
        | Filtre por
        strong  Pesquisa
        |  (nome contém) e clique na lupa. A tabela mostra
        strong  ID
        |  e
        strong  Nome
        | .
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de grupos de usuários")
      ol
        li Clique no
          strong  +
          |  para criar um grupo.
        li Em cada linha, clique em
          strong  Alterar
          |  para editar.

      h5.h5 3. Criar ou alterar
      figure.manual-figure
        img(:src="imgForm" alt="Formulário de grupo de usuários")
      ol
        li Informe o
          strong  Nome
          |  do grupo (obrigatório).
        li Clique em
          strong  Salvar
          | . Você volta à tela anterior.
        li Na edição, use
          strong  Logs
          |  para consultar o histórico do registro.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/38-config-usuario-grupos-lista.png"),
      imgForm: require("@/assets/manuais/38a-config-usuario-grupos-form.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
